import { render } from "./GlobalUploadProgressComponent.vue?vue&type=template&id=bdc2c566&ts=true"
import script from "./GlobalUploadProgressComponent.vue?vue&type=script&lang=ts"
export * from "./GlobalUploadProgressComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__